export const formatNumberWithCommas = (value: string): string => {
  const numericValue = value.replace(/[^0-9]/g, "");

  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const unformatNumberToKobo = (formattedValue: string): number => {
  const numericValue = formattedValue.replace(/,/g, "");
  const koboValue = parseFloat(numericValue) * 100;
  return Math.round(koboValue);
};

type CurrencyCode =
  | "USD" // US Dollar
  | "EUR" // Euro
  | "GBP"
  | "NGN"; // British Pound

export function formatCurrency(
  value: number,
  currency: CurrencyCode = "NGN",
  locale: string = "en-US"
): string {
  let addonStart = "";

  if (currency === "NGN") addonStart = "₦";

  return (
    addonStart +
    new Intl.NumberFormat(locale, {
      // style: 'currency',
      currency,
      // currencyDisplay: 'symbol', // This ensures the currency symbol is shown
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  );
}
